import carTypesOptions from "./car_types";
import heavyCarTypesOptions from "./heavy_car_types";
import carBrandsOptions from "./car_brands";
import carDeducibleOptions from "./car_deducible";
import constructionMaterialsOptions from "./construction_materials";
export { carTypesOptions, heavyCarTypesOptions, carBrandsOptions, carDeducibleOptions, constructionMaterialsOptions };